import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import Color from "color";

export const getShadows = (color: string, prefix = "e") => {
    const firstColor = Color(color).alpha(0.05);
    const secondColor = Color(color).alpha(0.1);
    const firstShadow = `${pxToRem(0, 0, 1, 0)} ${firstColor}`;

    const shadows: { [key: string]: string } = {};
    shadows.dragVertical = `${pxToRem(0, 18, 16, -19)} ${secondColor}, ${pxToRem(0, -18, 16, -19)} ${secondColor}`;
    // Down (Default)
    shadows[`${prefix}20`] = `${firstShadow}, ${pxToRem(0, 1, 3, 0)} ${secondColor}`;
    shadows[`${prefix}40`] = `${firstShadow}, ${pxToRem(0, 2, 4, 0)} ${secondColor}`;
    shadows[`${prefix}60`] = `${firstShadow}, ${pxToRem(0, 4, 8, 0)} ${secondColor}`;
    shadows[`${prefix}80`] = `${firstShadow}, ${pxToRem(0, 8, 16, 0)} ${secondColor}`;
    shadows[`${prefix}100`] = `${firstShadow}, ${pxToRem(0, 16, 24, 0)} ${secondColor}`;
    // Up
    shadows[`${prefix}20Up`] = `${firstShadow}, ${pxToRem(0, -1, 3, 0)} ${secondColor}`;
    shadows[`${prefix}40Up`] = `${firstShadow}, ${pxToRem(0, -2, 4, 0)} ${secondColor}`;
    shadows[`${prefix}60Up`] = `${firstShadow}, ${pxToRem(0, -4, 8, 0)} ${secondColor}`;
    shadows[`${prefix}80Up`] = `${firstShadow}, ${pxToRem(0, -8, 16, 0)} ${secondColor}`;
    shadows[`${prefix}100Up`] = `${firstShadow}, ${pxToRem(0, -16, 24, 0)} ${secondColor}`;

    return shadows;
};

const shadows: Styleguide["shadows"] = getShadows("#303133");

export default shadows;
